import React, {CSSProperties, MouseEventHandler, RefObject} from 'react';
import classNames from 'classnames';


import './icon.css';


export type IconSize = 14 | 16 | 20 | 24 | 32 | 48 | null;

export interface IconBoxProps {
    children: React.ReactNode;
    size?: IconSize;
    onClick?: MouseEventHandler;
    className?: string;
    style?: CSSProperties;
    colorOverwritten?: boolean;
    innerRef?: RefObject<any>;
    additionalPadding?: number;
    fullHeight?: boolean;
}

export type IconProps = Omit<IconBoxProps, 'children'>

export const IconBox = React.forwardRef<HTMLElement, IconBoxProps>(
    (
        {
            size = null,
            onClick,
            className,
            style,
            children,
            colorOverwritten = false,
            additionalPadding = 0,
            fullHeight = false,
        }: IconBoxProps,
        ref
    ) => {
        if (additionalPadding) {
            style = { ...style, padding: `${additionalPadding}px` };
        }

        return (
            <span
                style={style}
                ref={ref}
                className={classNames({
                    icon: true,
                    [`icon--${size}`]: !!size,
                    [className!]: !!className,
                    'icon--clickable': !!onClick,
                    'icon--inherit-color': !colorOverwritten,
                    'icon--fullHeight': fullHeight,
                })}
                onClick={onClick}
            >
                {fullHeight ? <div className={`icon icon--${size}`}>{children}</div> : children}
            </span>
        );
    }
);
